import React, { useState, useEffect } from 'react';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import LoadingButton from '@mui/lab/LoadingButton';
import TextField from '@mui/material/TextField';
import { useLocation, useNavigate } from 'react-router-dom';
import { useViewPropertyQuery, useAddPolicyMutation, useGetPermissionQuery } from '../../../services/dvagent';
import { Toaster } from '../attributes';
import { getToken, storeAdmin, getUsername } from '../../../services/LocalStorageService';

const commonBorderStyle = {
  border: '1px solid #ccc',
  borderRadius: '10px',
  padding: '10px',
  height: '250px',
  overflowY: 'auto',
};

const listHeaderStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

const listItemStyle = {
  margin: '2px',
  padding: '4px',
  borderRadius: '4px',
  border: '1px solid #ededed',
  cursor: 'move',
  backgroundColor: 'white',
};

const searchInputStyle = {
  margin: '10px 0',
  padding: '2%',
  width: '70%',
  border: '1px solid #ededed',
  borderRadius: '5px',
};

const List = ({
    name,
    items,
    selectedItems,
    searchQuery,
    searchQuery1,
    handleDragStart,
    handleDropItems,
    filteredItems,
    filteredSelectedItems,
    onSearchQueryChange,
    onSearchQuery1Change,
  }) => {
      const handleDragOver = (e) => {
        e.preventDefault();
    };

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <div
        onDragOver={handleDragOver}
        onDrop={(e) => handleDropItems(e, 'available')}
        style={{
          ...commonBorderStyle,
          flex: 1,
        }}
      >
        <div style={{ ...listHeaderStyle, position: 'sticky', top: -10, zIndex: 1, background: '#F9FAFB' }}>
          <strong style={{ color: "#B7B7B7", fontStyle: "italic", marginLeft: "10%" }}>{name}</strong>
          <input
            type="text"
            placeholder="Search items"
            value={searchQuery}
            onChange={onSearchQueryChange}
            style={searchInputStyle}
          />
        </div>

        {filteredItems
          .filter((item) => !filteredSelectedItems.some((selectedItem) => selectedItem.id === item.id))
          .map((item) => (
            <div
              key={item.id}
              draggable
              onDragStart={(e) => handleDragStart(e, item)}
              style={listItemStyle}
            >
              <Checkbox value={item.id} onChange={(e) => handleDropItems(e, 'selected')}  />
              {item.name}
            </div>
          ))}
      </div>
      <div
        onDragOver={handleDragOver}
        onDrop={(e) => handleDropItems(e, 'selected')}
        style={{
          ...commonBorderStyle,
          marginLeft: '20px',
          flex: 1,
        }}
      >
        <div style={{ ...listHeaderStyle, position: 'sticky', top: -10, zIndex: 1, background: '#F9FAFB' }}>
          <strong style={{ color: "#B7B7B7", fontStyle: "italic", marginLeft: "10%" }}>Picked</strong>
          <input
            type="text"
            placeholder="Search items"
            value={searchQuery1}
            onChange={onSearchQuery1Change}
            style={searchInputStyle}
          />
        </div>

        {filteredSelectedItems.map((item) => (
          <div
            key={item.id}
            draggable
            onDragStart={(e) => handleDragStart(e, item)}
            style={{
              ...listItemStyle,
              backgroundColor: '#ccc',
            }}
          ><Checkbox checked value={item.id} onChange={(e) => handleDropItems(e, 'available')}/>
            {item.name}
          </div>
        ))}
      </div>
    </div>
  );
};

const Add = () => {

  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const [policyName, setPolicyName] = useState();
  const [policyNameError, setPolicyNameError] = useState('');
  const [propertyListError, setPropertyListError] = useState('');
  const [permissionListError, setPermissionListError] = useState('');

  const [property, setProperty] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState([]);
  const [searchPropertyQuery, setSearchPropertyQuery] = useState('');
  const [searchPropertyQuery1, setSearchPropertyQuery1] = useState('');

  const [permission, setPermission] = useState([])
  const [selectedPermission, setSelectedPermission] = useState([]);
  const [searchPermissionQuery, setSearchPermissionQuery] = useState('');
  const [searchPermissionQuery1, setSearchPermissionQuery1] = useState('');

  const [buttonLabel, setButtonLabel] = useState("ADD");
  const [addPolicyMutation] = useAddPolicyMutation();
  const { data: propertyData, isSuccess: propretyIsSuccess, error: propertyError } = useViewPropertyQuery({"token":getToken(), "location":location});
  const { data: permisstionData, isSuccess: permisstionIsSuccess, error: permisstionError } = useGetPermissionQuery({"token":getToken(), "location":location});
  const [toasterData, setToasterData] = useState({
    trigger: false,
    status: true,
    symbol: '✔',
    message: '',
  });

  const filteredProperty = property.filter((property) =>
    property.name.toLowerCase().includes(searchPropertyQuery.toLowerCase())
  ).sort((a, b) => a.name.localeCompare(b.name));

  const filteredSelectedProperty = selectedProperty.filter((property) =>
    property.name.toLowerCase().includes(searchPropertyQuery1.toLowerCase())
  ).sort((a, b) => a.name.localeCompare(b.name));

  const filteredPermission = permission.filter((permission) =>
    permission.name.toLowerCase().includes(searchPermissionQuery.toLowerCase())
  ).sort((a, b) => a.name.localeCompare(b.name));

  const filteredSelectedPermission = selectedPermission.filter((permission) =>
    permission.name.toLowerCase().includes(searchPermissionQuery1.toLowerCase())
  ).sort((a, b) => a.name.localeCompare(b.name));

  const handleDragStartProperty = (e, item) => {
    e.dataTransfer.setData('text/plain', String(item.id));
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragStartPermission = (e, item) => {
    e.dataTransfer.setData('text/plain', String(item.id));
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDropSetProperty = (e, targetList) => {
    setPropertyListError('')
    e.preventDefault();
    let itemId
    try {
      itemId = Number(e.dataTransfer.getData('text/plain'));
    } catch (error) {
      itemId = Number(e.target.value)
    }
    const draggedProperty = property.find((property) => property.id === itemId);

    if (draggedProperty) {
      const updatedProperty = property.filter((property) => property.id !== itemId);
      const updatedSelectedProperty = selectedProperty.filter((property) => property.id !== itemId);

      if (targetList === 'available') {
        setProperty([...updatedProperty, draggedProperty]);
        setSelectedProperty(updatedSelectedProperty);
      } else if (targetList === 'selected') {
        setProperty([...updatedProperty, draggedProperty]);
        setSelectedProperty([...updatedSelectedProperty, draggedProperty]);
      }
    }
  };

  const handleDropSetPermission = (e, targetList) => {
    setPermissionListError('');
    e.preventDefault();
    let itemId
    try {
      itemId = Number(e.dataTransfer.getData('text/plain'));
    } catch (error) {
      itemId = Number(e.target.value)
    }
    const draggedPermission = permission.find((permission) => permission.id === itemId);
  
    if (draggedPermission) {
      const updatedPermission = permission.filter((permission) => permission.id !== itemId);
      const updatedSelectedPermission = selectedPermission.filter((Permission) => Permission.id !== itemId);
  
      if (targetList === 'available') {
        setPermission([...updatedPermission, draggedPermission]);
        setSelectedPermission(updatedSelectedPermission);
      } else if (targetList === 'selected') {
        setPermission([...updatedPermission, draggedPermission]);
        setSelectedPermission([...updatedSelectedPermission, draggedPermission]);
      }
    }
  };
  
  const handlePolicyName = (event) => {
    setPolicyName(event.target.value);
    setPolicyNameError('');
  };

  const handleAddPolicy = async () => {
    setSearchPropertyQuery("");
    setSearchPropertyQuery1("");
    setSearchPermissionQuery("");
    setSearchPermissionQuery1("");
    if (!policyName) {
      setPolicyNameError('Please enter policy name');
    }
    if (selectedProperty.length === 0){
      setPropertyListError('Please select property')
    }
    if (selectedPermission.length === 0){
      setPermissionListError('Please select permission')
    }
    if (!policyName || selectedProperty.length === 0 || selectedPermission.length === 0) {
      return
    }
    try {
      setButtonLabel("Loading...");
    
      const propertyIds = selectedProperty.map((item) => item.id);
      const permissionIds = selectedPermission.map((item) => item.id);

      const formData = new FormData();
      formData.append("name", policyName);
      formData.append("properties", JSON.stringify(propertyIds));
      formData.append("features", JSON.stringify(permissionIds));

      const res = await addPolicyMutation({token:getToken(), data:formData });      
      if (res.error) {
        if (res.error.status===400) {
          showToast(false, 'ⓘ', 'Policy already exists');
        } else if (res.error.status===500) {
          showToast(false, 'ⓘ', 'Something went wrong, please try again');
        } else if (res.error.status==="FETCH_ERROR") {
          showToast(false, 'ⓘ', 'Unable to add policy, server error');
        } else {
          showToast(false, 'ⓘ', 'Something went wrong, please try again');
        }
      }
      if (res.data) {
        showToast(true, '✔', 'Policy added');
        setTimeout(() => {
          navigate('/cloud/users', {state:{ dropdownState: 'Policies' }});
        }, 3000);
      }
    } catch (error) {
      console.error("An unexpected error occurred:", error);
    } finally {
      setButtonLabel("ADD");
    }
  };

  const handleCancel = () => {
    setSearchPropertyQuery("");
    setSearchPropertyQuery1("");
    setSelectedProperty([]);
    setSearchPermissionQuery("");
    setSearchPermissionQuery1("");
    setSelectedPermission([]);
  };
  
  useEffect(() => {
    setLoading(false);

    if ( propertyError || permisstionError ) {
      if (propertyError.status === 401 || permisstionError.status === 401) {
        // showToast(false, 'ⓘ', 'Unauthorized User');
        storeAdmin('false');
        navigate('/');
      } else {
        showToast(false, 'ⓘ', 'Something went wrong, server error');
      }
    }
    if (propertyData && propretyIsSuccess) {
      setProperty(propertyData.properties)
    }
    if (permisstionData && permisstionIsSuccess) {
      setPermission(permisstionData.data)
    }
    setTimeout(() => {
      setLoading(true);
    }, 1000);
  }, [ propertyData, propretyIsSuccess, permisstionData, permisstionIsSuccess ]);

  const showToast = (status, symbol, message) => {
    setToasterData({
      trigger: true,
      status,
      symbol,
      message,
    });

    setTimeout(() => {
      setToasterData((prev) => ({
        ...prev,
        trigger: false,
      }));
    }, 5000); 
  };

  return (
    <>
      {toasterData.trigger && (
        <Toaster
          trigger={toasterData.trigger}
          status={toasterData.status}
          symbol={toasterData.symbol}
          message={toasterData.message}
        />
      )}
      <Grid item sx={{ width: '250%' }}>
          <FormControl sx={{ mt: 1 }} fullWidth size="small">
            <TextField
              label="Policy Name"
              variant="outlined"
              size="small"
              value={policyName}
              onChange={handlePolicyName}
              helperText={policyNameError}
              error={Boolean(policyNameError)}
              autoComplete="off"
            />
          </FormControl>

          <Box
              component="form"
              sx={{
              '& .MuiTextField-root': { m: 4, width: '30ch' },
              my: 3,
              }}
              noValidate
              autoComplete="off"
          >
              <List
                name="Property"
                items={property}
                selectedItems={selectedProperty}
                searchQuery={searchPropertyQuery}
                searchQuery1={searchPropertyQuery1}
                handleDragStart={handleDragStartProperty}
                handleDropItems={handleDropSetProperty}
                filteredItems={filteredProperty}
                filteredSelectedItems={filteredSelectedProperty}
                onSearchQueryChange={(e) => setSearchPropertyQuery(e.target.value)}
                onSearchQuery1Change={(e) => setSearchPropertyQuery1(e.target.value)}
              />
              <Typography style={{ color: '#FF4842', fontSize: '12px', marginLeft: '1%' }}>{propertyListError} </Typography>
          </Box>
          
          <Box
              component="form"
              sx={{
              '& .MuiTextField-root': { m: 4, width: '30ch' },
              my: 3,
              }}
              noValidate
              autoComplete="off"
          >
              <List
                name="Permission"
                items={permission}
                selectedItems={selectedPermission}
                searchQuery={searchPermissionQuery}
                searchQuery1={searchPermissionQuery1}
                handleDragStart={handleDragStartPermission}
                handleDropItems={handleDropSetPermission}
                filteredItems={filteredPermission}
                filteredSelectedItems={filteredSelectedPermission}
                onSearchQueryChange={(e) => setSearchPermissionQuery(e.target.value)}
                onSearchQuery1Change={(e) => setSearchPermissionQuery1(e.target.value)}
              />
              <Typography style={{ color: '#FF4842', fontSize: '12px', marginLeft: '1%' }}>{permissionListError}</Typography>
          </Box>

        <Grid item xs={12}>
          <Box
            sx={{
              display: 'flex',
            }}
          >
            <FormControl sx={{width: { xs: '100%', sm: '100%', md:'15%', xl:'10%' }}}>
              <Button
                onClick={() => handleAddPolicy()}
                disabled={buttonLabel==="Loading..."}
                sx={{
                  color: '#FFF',
                  border: 1,
                  borderColor: '#A8A196',
                  bgcolor: '#A8A196',
                  marginRight:2,
                  ":hover": {
                      bgcolor: "#7D7463",
                      borderColor: '#7D7463',
                  }
                }}>
                {buttonLabel}
              </Button>
            </FormControl>
            <FormControl sx={{width: { xs: '100%', sm: '100%', md:'15%', xl:'10%' }}}>
              <Button
                onClick={handleCancel}
                sx={{
                  color: '#9BA4B5',
                  border: 1,
                  borderColor: '#B5C0D0',
                  bgcolor: '#FFF',
                  ":hover": {
                      bgcolor: "#EEEEEE",
                      borderColor: '#EEEEEE',
                  }
                }}
                >
                CLEAR
              </Button>
            </FormControl>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};
export default Add;
